export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0068.53244563.webp";